module.exports = __webpack_public_path__ + "static/media/icon_edit_grey.10779de5.svg";